/**
 * Slice data between `start` ~ `end`.
 * Same with https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/slice
 */
export const Slice = (options) => {
    const { start, end } = options;
    return (data) => data.slice(start, end);
};
Slice.props = {};
//# sourceMappingURL=slice.js.map